import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Instrument_Report_Table = ({ setEdit }) => {
  const data = [
    {
      instrumentId: "INS101",
      instrumentName: "Coal Testing Machine",
      model: "CTM-2000",
      serialNo: "2025-BC-789",
      calibratedBy: "Prachi Desai",
      calibrationDue: "07",
      lastCalibrated: "15 MAR 2025",
      nextCalibration: "23 JAN 2025",
      certificateNo: "CERT-000567-2025",
    },
    {
      instrumentId: "INS102",
      instrumentName: "Coal Testing Machine",
      model: "CTM-2000",
      serialNo: "2025-BC-789",
      calibratedBy: "Rahul Chavan",
      calibrationDue: "03",
      lastCalibrated: "15 MAR 2025",
      nextCalibration: "23 JAN 2025",
      certificateNo: "CERT-000568-2025",
    },
    {
      instrumentId: "INS103",
      instrumentName: "Laboratory Moisture Analyzer",
      model: "LMX-450",
      serialNo: "2025-BC-789",
      calibratedBy: "Deep Patil",
      calibrationDue: "01",
      lastCalibrated: "15 MAR 2025",
      nextCalibration: "24 JAN 2025",
      certificateNo: "CERT-000569-2025",
    },
    {
      instrumentId: "INS104",
      instrumentName: "Volatile Matter Tester",
      model: "CVM-550",
      serialNo: "2025-BC-789",
      calibratedBy: "Amardip Roy",
      calibrationDue: "06",
      lastCalibrated: "15 MAR 2025",
      nextCalibration: "25 JAN 2025",
      certificateNo: "CERT-000570-2025",
    },
    {
      instrumentId: "INS105",
      instrumentName: "Proximate Analyzer",
      model: "PGM-310",
      serialNo: "2025-BC-789",
      calibratedBy: "Prachi Desai",
      calibrationDue: "02",
      lastCalibrated: "15 MAR 2025",
      nextCalibration: "23 JAN 2025",
      certificateNo: "CERT-000571-2025",
    },
    {
      instrumentId: "INS106",
      instrumentName: "Coal Testing Machine",
      model: "CTM-2000",
      serialNo: "2025-BC-789",
      calibratedBy: "Rahul Chavan",
      calibrationDue: "04",
      lastCalibrated: "15 MAR 2025",
      nextCalibration: "23 JAN 2025",
      certificateNo: "CERT-000572-2025",
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" />
                </th>
                <th>Instrument ID</th>
                <th>Instrument Name</th>
                <th>Model</th>
                <th>Serial No.</th>
                <th>Calibrated By</th>
                <th>Calibration Due</th>
                <th>Last Calibrated</th>
                <th>Next Calibration</th>
                <th>Certificate No</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{row.instrumentId}</td>
                  <td>{row.instrumentName}</td>
                  <td>{row.model}</td>
                  <td>{row.serialNo}</td>
                  <td>{row.calibratedBy}</td>
                  <td>{row.calibrationDue}</td>
                  <td>{row.lastCalibrated}</td>
                  <td>{row.nextCalibration}</td>
                  <td>{row.certificateNo}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Instrument_Report_Table;
